var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20215 13.6V2.17603H8.71415C10.1061 2.17603 10.8101 2.36803 11.4021 2.88003C12.0101 3.40803 12.3301 4.25603 12.3301 5.29603C12.3301 6.38403 12.0421 7.10403 11.3701 7.63203C11.8341 8.03203 11.9301 8.12803 12.0741 8.35203C12.3781 8.83203 12.5381 9.55203 12.5381 10.4C12.5381 11.6 12.1861 12.464 11.4821 13.008C10.8901 13.44 10.2181 13.6 8.92215 13.6H4.20215ZM6.65015 6.81603H8.53815C9.51415 6.81603 9.89815 6.43203 9.89815 5.47203C9.89815 4.49603 9.51415 4.12803 8.53815 4.12803H6.65015V6.81603ZM6.65015 11.648H8.74615C9.70615 11.648 10.0901 11.232 10.0901 10.208C10.0901 9.16803 9.70615 8.76803 8.74615 8.76803H6.65015V11.648Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.25e9cbe81f122337c21eefe6bf586020.svg";
export { ForwardRef as ReactComponent };